import r from "./slotShouldForwardProp.js";
const t = (o) => r(o) && o !== "classes";
export {
  t as default
};
